export const FIND_DOCUMENT_SUCCESS = 'FIND_DOCUMENT_SUCCESS';

export const findDocumentSuccess = document => ({
    type: FIND_DOCUMENT_SUCCESS,
    payload: { document },
});
